// extracted by mini-css-extract-plugin
export var quote = "styles-module--quote--J_E9r";
export var testimonialText = "styles-module--testimonialText--331Vi";
export var testimonialUserContainer = "styles-module--testimonialUserContainer--2BN_1";
export var avatar = "styles-module--avatar--ATV4-";
export var userName = "styles-module--userName--2bQ7Z";
export var cardContent = "styles-module--cardContent--3lKxX";